module.exports = __webpack_public_path__ + "img/barcelo-resort-3.a20a595f.jpg";